import { SAMPLE_QUOTE } from './sampleQuote';

export const QUOTE_ACCEPTED_SAMPLE = {
  quote: SAMPLE_QUOTE,
  selectedBidOption: SAMPLE_QUOTE.bid_items[0].bid.bid_options[0],
  signedBy: 'Sarah Mitchell',
  organizationName: 'Skyward Aviation',
};
